import Layout from '@/components/layout';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import '@mantine/core/styles.css';
import '@/styles/globals.css';
import { wrapper } from '@/store';
import ScrollToTop from '@/components/ScrollToTop/ScrollToTop';

function App({ Component, ...rest }) {
    const { store, props } = wrapper.useWrappedStore(rest);
    const { pageProps } = props;

    return (
        <MantineProvider
            withGlobalStyles
            withNormalizeCSS
            theme={{
                primaryColor: 'blue',
            }}
        >
            <Notifications />
            <ScrollToTop/>
            <Layout 
                initialMenu={pageProps.initialMenu}
                initialDeviceType={pageProps.initialDeviceType}
            >
                <Component {...pageProps} />
            </Layout>
        </MantineProvider>
    );
}

export default wrapper.withRedux(App);